export default "__VITE_ASSET__5abc6e50__"